import React, { memo } from 'react';

import { Button } from '@chakra-ui/react';
import { PDFDownloadLink } from '@react-pdf/renderer';

import { type CoachShare } from '../coach-share';
import { PdfContent } from '../coach-share/PdfContent';

type DownloadPdfProps = {
  result: CoachShare;
  averageScore: number;
  buttonContent: React.ReactNode;
};

const DownloadPdfComponent: React.FC<DownloadPdfProps> = ({
  result,
  averageScore,
  buttonContent,
}) => {
  return (
    <PDFDownloadLink
      document={<PdfContent result={result} averageScore={averageScore} />}
      fileName="synapsai-coach-interview.pdf"
    >
      {
        ((props: { loading: boolean }) =>
          props.loading ? (
            <Button minW={{ base: '12', md: '36' }} isLoading />
          ) : (
            <Button
              borderWidth="1px"
              borderColor="gray.100"
              display="flex"
              justifyContent="center"
              alignItems="center"
              paddingY={2}
              paddingX={3}
              fontSize={14}
              borderRadius={8}
            >
              {buttonContent}
            </Button>
          )) as unknown as React.ReactNode
      }
    </PDFDownloadLink>
  );
};

export const DownloadReport = memo(DownloadPdfComponent, () => true);
